import React from "react";
import { Trans } from "react-i18next";
import moment from "moment";
import { label } from "./orderFormat";

// Status history comes from OrderStatuses (order.status), one row per status with
// updatedAt = last time the order reached it. Orders created before history was
// recorded on every change only have their first row, so the current status is
// appended when it is missing from the end of the list.
const StatusTimeline = ({ order }) => {
  const rows = (order.status || []).map(s => ({
    name: label(s),
    date: s.OrderStatus?.updatedAt,
  }));
  const last = order.status?.[order.status.length - 1];
  if (order.currentStatus && last?.id != order.currentStatusId)
    rows.push({ name: label(order.currentStatus), date: null });

  if (rows.length == 0)
    return <p className="text-muted"><Trans>No status history</Trans></p>;

  return (
    <ul className="verti-timeline list-unstyled">
      {rows.map((row, index) => {
        const active = index == rows.length - 1;
        return (
          <li className={`event-list ${active ? "active" : ""}`} key={index}>
            <div className="event-timeline-dot">
              <i className={`font-size-18 bx ${active ? "bxs-right-arrow-circle bx-fade-right" : "bx-right-arrow-circle"}`} />
            </div>
            <div className="flex-shrink-0 d-flex">
              <div className="me-3" style={{ minWidth: 150 }}>
                <h5 className="font-size-14">
                  {row.date ? moment(row.date).format("YYYY-MM-DD HH:mm") : <Trans>Current</Trans>}
                  <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                </h5>
              </div>
              <div className="flex-grow-1">
                <div><Trans>{row.name}</Trans></div>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default StatusTimeline;
